import { render, staticRenderFns } from "./QuestionReserve.vue?vue&type=template&id=d8e8476a&scoped=true"
import script from "./QuestionReserve.vue?vue&type=script&lang=js"
export * from "./QuestionReserve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e8476a",
  null
  
)

export default component.exports